import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { LOGIN_PATH } from "../appConstants";

const LayoutWrapper = () => {
    const auth = useSelector((state) => state.auth);
    if (!auth.isAuthenticated) {
        return <Navigate to={LOGIN_PATH} replace />;
    }

    return (
        <>
         {/* <Suspense fallback={<CircularProgress size={24} />}> */}
         <Outlet />
         {/* </Suspense>  */}
        </>
    );
};

export default LayoutWrapper;
